export enum Entity {
    USERS = 'users',
    ROBOTS = 'robots',
    GROUPS = 'groups',
}

export type EntityEnumType = typeof Entity[keyof typeof Entity];
